export default {
  optOut: state => state.optOut,
  mobilePortrait: state => state.mobilePortrait,
  fullscreenEnabled: state => state.fullscreenEnabled,
  topmenu: state => state.topmenu,
  route: state => state.route,
  getThemedVar: state => (prop, def) => (state.theme && prop in state.theme
    ? state.theme[prop]
    : def),
  contactFormFieldsAllowed: (_, getters, __, rootGetters) => ({
    zip: getters.getThemedVar('unitSingleContactFormZip', false) ||
      !!rootGetters['project/settings'].rebla_form_fields,
    birthyear: getters.getThemedVar('unitSingleContactFormBirthyear', false) ||
      !!rootGetters['project/settings'].rebla_form_fields,
    message: getters.getThemedVar('unitSingleContactFormMessage', true),
  }),
  primaryColor: (_, getters, __, rootGetters) => getters.getThemedVar(
    'primaryColor',
    rootGetters['project/settings'].profile_color1,
  ),
  fillOpacity: (_, getters, __, rootGetters) => getters.getThemedVar(
   'fillOpacity',
   rootGetters['project/settings'].mask_opacity,
  ),
    hoverfillOpacity: (_, getters, __, rootGetters) => getters.getThemedVar(
   'hoverfillOpacity',
   rootGetters['project/settings'].mask_hover_opacity,
  ),
  exteriorId: state => state.routeParams && +state.routeParams.exteriorId,
  exteriorNavBarVisible: state => state.exteriorNavBarVisible,
  isMiniMapVisible: state => state.isMiniMapVisible,
};
